import React from "react";
import { Box, Card, CardContent, CardMedia, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { motion } from "framer-motion"
import { thumbAnimationt1, thumbAnimationt2, thumbAnimationt3 } from './animationW/animationW';

import { CiStar } from 'react-icons/ci'
import { IWinner } from './winnersData'

import "./Winners.css";
import '../RusStat/RusStat.css'



interface WinnersProps {
   winners: IWinner[];
}

const Winners: React.FC<WinnersProps> = ({ winners }: any): JSX.Element => {



   return (

      <Card sx={{ minWidth: 275 }}>
         <CardContent className='winner_stat_card' sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Typography className='title_winner' variant="h4" gutterBottom>
               Statistics of the winners of the last event <br />
               (21.04.2023)
            </Typography>
            <span></span>


            <div>
               <motion.ul initial='hidden'
                  whileInView='visible'
                  className="wrapper"
                  viewport={{ amount: 0.2, once: true }}
               >
                  {/* второе место */}
                  <motion.li
                     variants={thumbAnimationt1}
                     className="second_place list_item">
                     <div className="thumb">


                        <Avatar className="avatar_place" sx={{ bgcolor: 'red' }} aria-label="recipe">
                           {winners[1].photo ? <CardMedia
                              component="img"
                              height="100"
                              image={winners[1].photo}
                              alt={winners[1].name}
                           /> : <Box sx={{ fontSize: 40 }}>{winners[1].name[0]}</Box>}
                        </Avatar>
                        <motion.p
                           className="thumb_name_person"
                           animate={{ rotate: [0, 0, 10, -10, 0, 0] }}
                           transition={{
                              duration: 2,
                              ease: "easeInOut",
                              times: [0, 0.2, 0.5, 0.8, 1],
                              repeat: Infinity,
                              repeatDelay: 1
                           }}
                        >{winners[1].name}</motion.p>
                     </div>
                     <div className="pedistal">
                        {/* <CiStar /> */}
                        <p className="number_place">2</p>
                        <img className="plase_icon" src="./img/wreath.svg" alt="winner" />
                        <p className="text_piedistal">number of votes</p>
                        <p className="text_piedistal">{winners[1].voit}</p>
                     </div>
                  </motion.li>

                  {/* первое место */}
                  <motion.li
                     variants={thumbAnimationt2}
                     className="first_place list_item">
                     <div className="thumb">
                        <Avatar className="avatar_place" sx={{ bgcolor: 'red' }} aria-label="recipe">
                           {winners[0].photo ? <CardMedia
                              component="img"
                              // height="100"
                              image={winners[0].photo}
                              alt={winners[0].name}
                           /> : <Box sx={{ fontSize: 40 }}>{winners[0].name[0]}</Box>}
                        </Avatar>
                        <motion.p
                           className="thumb_name_person"
                           animate={{ rotate: [0, 0, 10, -10, 0, 0] }}
                           transition={{
                              duration: 2,
                              ease: "easeInOut",
                              times: [0, 0.2, 0.5, 0.8, 1],
                              repeat: Infinity,
                              repeatDelay: 2
                           }}
                        >{winners[0].name}</motion.p>
                     </div>
                     <div className="pedistal">
                        {/* <CiStar /> */}
                        <p className="number_place">1</p>

                        <img className="plase_icon" src="./img/wreath.svg" alt="winner" />
                        <p className="text_piedistal">number of votes</p>
                        <p className="text_piedistal">{winners[0].voit}</p>
                     </div>
                  </motion.li>
                  {/* третье место */}
                  <motion.li
                     variants={thumbAnimationt3}
                     className="third_place">
                     <div className="thumb">
                        <Avatar className="avatar_place" sx={{ bgcolor: 'red' }} aria-label="recipe">
                           {winners[2].photo ? <CardMedia
                              component="img"
                              height="100"
                              image={winners[2].photo}
                              alt={winners[2].name}
                           /> : <Box sx={{ fontSize: 40 }}>{winners[2].name[0]}</Box>}
                        </Avatar>
                        <motion.p className="thumb_name_person"
                           animate={{ rotate: [0, 0, 10, -10, 0, 0] }}
                           transition={{
                              duration: 2,
                              ease: "easeInOut",
                              times: [0, 0.2, 0.5, 0.8, 1],
                              repeat: Infinity,
                              repeatDelay: 5
                           }}
                        >{winners[2].name}</motion.p>
                     </div>
                     <div className="pedistal">
                        {/* <CiStar /> */}
                        <p className="number_place">3</p>
                        <img className="plase_icon" src="./img/wreath.svg" alt="winner" />
                        <p className="text_piedistal">number of votes</p>
                        <p className="text_piedistal">{winners[2].voit}</p>
                     </div>
                  </motion.li>
               </motion.ul>
            </div>

         </CardContent>
      </Card>

   );
};

export default Winners;

